
import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import { User } from 'firebase/auth';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

interface SipCalculatorProps {
  currentUser: User | null;
}

const SipCalculator: React.FC<SipCalculatorProps> = ({ currentUser }) => {
  const [monthlyInvestment, setMonthlyInvestment] = useState<number>(0);
  const [expectedReturn, setExpectedReturn] = useState<number>(0);
  const [timePeriod, setTimePeriod] = useState<number>(0);
  const [maturityAmount, setMaturityAmount] = useState<number | null>(null);

  const calculateSip = () => {
    const rate = expectedReturn / 100 / 12; // Monthly rate
    const months = timePeriod * 12; // Total months

    if (rate === 0) {
      setMaturityAmount(monthlyInvestment * months);
      return;
    }

    const futureValue = monthlyInvestment * (((1 + rate) ** months - 1) / rate) * (1 + rate);
    setMaturityAmount(futureValue);
  };

  return (
    <Card className="p-4 shadow-sm">
      <h4 className="mb-4">SIP Calculator</h4>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Monthly Investment (₹)</Form.Label>
          <Form.Control
            type="number"
            value={monthlyInvestment}
            onChange={(e) => setMonthlyInvestment(parseFloat(e.target.value))}
            placeholder="Enter monthly investment"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Expected Annual Return (%)</Form.Label>
          <Form.Control
            type="number"
            value={expectedReturn}
            onChange={(e) => setExpectedReturn(parseFloat(e.target.value))}
            placeholder="Enter expected annual return"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Time Period (Years)</Form.Label>
          <Form.Control
            type="number"
            value={timePeriod}
            onChange={(e) => setTimePeriod(parseFloat(e.target.value))}
            placeholder="Enter time period in years"
          />
        </Form.Group>

        <Button variant="primary" onClick={calculateSip} className="w-100">
          Calculate SIP
        </Button>
        {currentUser && maturityAmount !== null && (
          <Button variant="secondary" onClick={async () => {
            try {
              await addDoc(collection(db, `users/${currentUser.uid}/savedCalculations`), {
                calculatorType: 'sip',
                monthlyInvestment,
                expectedReturn,
                timePeriod,
                maturityAmount,
                timestamp: new Date(),
              });
              alert('SIP calculation saved!');
            } catch (e) {
              console.error('Error saving document: ', e);
              alert('Error saving calculation.');
            }
          }} className="w-100 mt-2">
            Save Calculation
          </Button>
        )}

        {maturityAmount !== null && (
          <div className="mt-4 text-center">
            <h5>Maturity Amount: ₹{maturityAmount.toFixed(2)}</h5>
          </div>
        )}
      </Form>
    </Card>
  );
};

export default SipCalculator;
